if (typeof ColorSwatches === 'undefined') {
  window.ColorSwatches = class ColorSwatches {
    constructor(element) {
      this.element = element;
      this.productId = element.dataset.productId;
      this.sectionId = element.dataset.sectionId;
      this.swatchButtons = element.querySelectorAll('.color-swatch');
    
    // Return early if no swatches found
    if (!this.swatchButtons || this.swatchButtons.length === 0) return;
    
    // Find the product card wrapper
    this.productCard = element.closest('.card-wrapper');
    if (!this.productCard) return;
    
    // Get the main product image and its parent link
    this.mainImage = this.productCard.querySelector('.card__media img:first-child');
    this.imageLink = this.productCard.querySelector('.card__media a.media');
    if (!this.mainImage) return;
    
    // Store original image data
    this.originalImageData = {
      src: this.mainImage.src,
      srcset: this.mainImage.srcset,
      alt: this.mainImage.alt,
      width: this.mainImage.width,
      height: this.mainImage.height
    };
    
    this.init();
  }
  
  init() {
    // Add click handlers to all swatches - use capture phase to catch events early
    this.swatchButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleSwatchClick(e), true);
    });
    
    // Set initial variant ID from the first selected swatch
    const selectedSwatch = this.element.querySelector('.color-swatch--selected');
    if (selectedSwatch && selectedSwatch.dataset.variantId) {
      this.updateQuickAddUrl(selectedSwatch.dataset.variantId);
      this.updateProductPageUrl(selectedSwatch.dataset.variantId);
    }
  }
  
  handleSwatchClick(event) {
    // Aggressively prevent navigation
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    const button = event.currentTarget;
    
    // Don't do anything if this swatch is already selected
    if (button.classList.contains('color-swatch--selected')) {
      return;
    }
    
    // Get image data from the clicked swatch
    const imageUrl = button.dataset.imageUrl;
    const imageSrcset = button.dataset.imageSrcset;
    const imageAlt = button.dataset.imageAlt;
    const imageWidth = button.dataset.imageWidth;
    const imageHeight = button.dataset.imageHeight;
    const variantId = button.dataset.variantId;
    
    // If there's no image data, don't proceed
    if (!imageUrl) return;
    
    // Remove selected class from all swatches
    this.swatchButtons.forEach(btn => {
      btn.classList.remove('color-swatch--selected');
    });
    
    // Add selected class to clicked swatch
    button.classList.add('color-swatch--selected');
    
    // Update the image with a smooth transition
    this.updateImage(imageUrl, imageSrcset, imageAlt, imageWidth, imageHeight);
    
    // Store the selected variant ID on the product card for quick-add
    if (variantId && this.productCard) {
      this.productCard.dataset.selectedVariantId = variantId;
      this.updateQuickAddUrl(variantId);
      this.updateProductPageUrl(variantId);
    }
    
    // Return false for extra safety
    return false;
  }
  
  updateQuickAddUrl(variantId) {
    // Update quick-add button URL to include the selected variant
    const quickAddButton = this.productCard.querySelector('[data-product-url]');
    if (quickAddButton && variantId && quickAddButton.dataset.productUrl) {
      const baseUrl = quickAddButton.dataset.productUrl.split('?')[0];
      quickAddButton.dataset.productUrl = `${baseUrl}?variant=${variantId}`;
    }
  }
  
  updateProductPageUrl(variantId) {
    // Update all product page links to include the selected variant
    if (!this.productCard || !variantId) return;
    
    const productLinks = this.productCard.querySelectorAll('a[href*="/products/"]');
    if (!productLinks || productLinks.length === 0) return;
    
    productLinks.forEach(link => {
      // Skip the quick-add button (it's handled separately)
      if (link.hasAttribute('data-product-url')) return;
      
      // Get the current href
      let href = link.getAttribute('href');
      if (!href || typeof href !== 'string') return;
      
      try {
        // Remove any existing variant parameter
        const baseUrl = href.split('?')[0].split('#')[0];
        const hash = href.includes('#') ? href.split('#')[1] : '';
        
        // Add the variant parameter
        const newUrl = `${baseUrl}?variant=${variantId}${hash ? '#' + hash : ''}`;
        link.setAttribute('href', newUrl);
      } catch (error) {
        // Silently fail for any individual link errors
        console.warn('Failed to update product link:', error);
      }
    });
  }
  
  updateImage(src, srcset, alt, width, height) {
    if (!this.mainImage) return;
    
    // Update the image immediately
    this.mainImage.src = src;
    if (srcset) this.mainImage.srcset = srcset;
    if (alt) this.mainImage.alt = alt;
    if (width) this.mainImage.width = parseInt(width) || width;
    if (height) this.mainImage.height = parseInt(height) || height;
  }
  };
}

// Initialize color swatches on page load (only once)
if (!window.colorSwatchesInitialized) {
  window.colorSwatchesInitialized = true;
  
  document.addEventListener('DOMContentLoaded', () => {
    const colorSwatchesElements = document.querySelectorAll('.color-swatches');
    colorSwatchesElements.forEach(element => {
      new window.ColorSwatches(element);
    });
  });

  // Handle dynamic content loading (for theme editor and infinite scroll)
  if (typeof Shopify !== 'undefined' && Shopify.theme) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event && event.target) {
        const colorSwatchesElements = event.target.querySelectorAll('.color-swatches');
        colorSwatchesElements.forEach(element => {
          new window.ColorSwatches(element);
        });
      }
    });
  }
}

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = window.ColorSwatches;
}

